<i18n src="./resources/locales.json"></i18n>

<template>
  <v-dialog v-model="dialog" persistent max-width="800px">
    <v-card color="surface lighten-1">
      <v-card-title primary-title>
        <div>
          <div v-once class="xtium-title">{{ $t('header.title') }}</div>
          <span v-once class="xtium-subtitle">{{ $t('header.subtitle') }}</span>
        </div>

        <v-spacer />

        <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>

      <v-divider />
      <v-card-text class="dialog-content">
        <EcsImageUpload ref="imageUpload" @selected-file="selectedFile" />
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />

        <v-btn id="update-profile-photo-cancel" text @click="close">
          {{ $t('buttons.cancel') }}
        </v-btn>
        <v-btn
          id="update-profile-photo-save"
          color="primary"
          :disabled="disableImageUpload"
          depressed
          @click="saveProfilePhoto"
        >
          {{ $t('buttons.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EcsImageUpload from '@/components/ecs-agent-info/EcsImageUpload';

export default {
  name: 'EcsUpdateProfilePhotoDialog',

  components: {
    EcsImageUpload
  },

  data() {
    return {
      dialog: false,
      disableImageUpload: true
    };
  },

  methods: {
    close() {
      this.dialog = false;
      this.$refs.imageUpload.reset();
    },

    open() {
      this.dialog = true;
      if (this.$refs.imageUpload) {
        this.$refs.imageUpload.reset();
      }
    },

    selectedFile(file) {
      this.disableImageUpload = !file;
    },

    saveProfilePhoto() {
      this.$emit('save-profile-photo', this.$refs.imageUpload.finalImageUrl);
      this.close();
    }
  }
};
</script>

<style>
.dialog-content {
  background-color: var(--v-surface-base);
}
</style>
